import { Users, Briefcase, Clock, MapPin, Accessibility, Crown, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Stars } from "@/components/Stars";
import { gbp } from "@/lib/constants";

export function TaxiCard({ offer, onSelect, onDetails }) {
  return (
    <div data-testid={`taxi-card-${offer.offer_id}`} className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:shadow-lg">
      <div className="flex flex-col sm:flex-row">
        <div className="relative h-44 w-full shrink-0 overflow-hidden bg-slate-100 sm:h-auto sm:w-56">
          <img src={offer.image} alt={offer.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
          <div className="absolute left-2 top-2 flex gap-1">
            {offer.executive && <Badge className="bg-navy text-white gap-1"><Crown size={11} /> Executive</Badge>}
            {offer.wheelchair && <Badge className="bg-emerald-600 text-white gap-1"><Accessibility size={11} /> WAV</Badge>}
          </div>
        </div>

        <div className="flex flex-1 flex-col p-4 sm:p-5">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h3 className="font-heading text-base font-semibold text-navy sm:text-lg">{offer.title}</h3>
              <p className="text-sm text-slate-500">{offer.operator_name}</p>
              <div className="mt-1 flex items-center gap-2">
                <Stars rating={offer.rating} />
                <span className="text-sm font-medium text-slate-700">{offer.rating}</span>
                <span className="text-xs text-slate-400">· {offer.trips.toLocaleString()} trips</span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold text-navy" data-testid={`taxi-price-${offer.offer_id}`}>{gbp(offer.total)}</div>
              <div className="text-xs text-slate-400">all-inclusive</div>
            </div>
          </div>

          <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-slate-600">
            <span className="flex items-center gap-1"><Users size={13} className="text-brand" /> Up to {offer.pax}</span>
            <span className="flex items-center gap-1"><Briefcase size={13} className="text-brand" /> {offer.bags} bags</span>
            <span className="flex items-center gap-1"><MapPin size={13} className="text-brand" /> {offer.pickup_eta_min} min away</span>
            <span className="flex items-center gap-1"><Clock size={13} className="text-brand" /> ~{offer.duration_minutes} min journey</span>
            {offer.available_247 && <span className="flex items-center gap-1 text-emerald-600"><Zap size={13} /> 24/7</span>}
          </div>

          <div className="mt-3 flex flex-wrap gap-1.5">
            {offer.features.slice(0, 4).map((f) => (
              <span key={f} className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-medium text-slate-600">{f}</span>
            ))}
          </div>

          <div className="mt-4 flex gap-2">
            <Button className="flex-1 bg-brand hover:bg-brand/90" onClick={() => onSelect(offer)} data-testid={`select-taxi-${offer.offer_id}`}>Select Taxi</Button>
            <Button variant="outline" onClick={() => onDetails(offer)} data-testid={`details-taxi-${offer.offer_id}`}>View Details</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
